import PropTypes from 'prop-types';
import moment from 'moment';

import StyledTD from './styledTd';

import {buildHandleEnterKeyPress} from '../utils/accessibility';

const DayCell = ({disabled, day, onClick, selectedDay}) => {
  if (!day.isSame(selectedDay, 'month')) {
    return <StyledTD />;
  }

  let handleClick = disabled ? () => {} : () => onClick(day);

  return (
    <StyledTD
      data-cy={`select-${day}`}
      disabled={disabled}
      isSelected={day.isSame(selectedDay, 'day')}
      onClick={handleClick}
      onKeyDown={buildHandleEnterKeyPress(handleClick)}
      tabIndex={0}>
      <span className="day-container">
        <span className="day">{day.format('D')}</span>
      </span>
    </StyledTD>
  );
};

DayCell.propTypes = {
  disabled: PropTypes.bool,
  day: PropTypes.instanceOf(moment).isRequired,
  onClick: PropTypes.func,
  selectedDay: PropTypes.instanceOf(moment),
};

DayCell.defaultProps = {
  disabled: false,
  onClick: () => {},
};

export default DayCell;
